module.exports = __webpack_public_path__ + "img/Labels.jpg.bv.0b391fb3.webp";